import { Component, Input, Output, EventEmitter } from "@angular/core";
import { LogService } from "@rubbl-core";
import { RangeSlider } from "@rubbl-search-results";

@Component({
  selector: "app-facet-range-slider",
  templateUrl: "./facet-range-slider.component.html",
})
export class FacetRangeSliderComponent {
  @Input() facetRange: RangeSlider;
  @Input() facetName: string;
  @Input() useCommas: boolean;

  @Output() rangeSliderChange = new EventEmitter();

  constructor(private logService: LogService) {}

  onChange() {
    this.rangeSliderChange.emit();
    if (this.facetRange.sliderSelected) {
      this.logService.pushTagToGtm({
        event: "searchFilter",
        filterCategory: this.facetName,
        filterSelection: `${this.facetRange.minValue}-${this.facetRange.maxValue}`,
      });
    }
  }
}
